import { CSSObject } from '@mui/material';

/**
 * Narrow scrollbar chrome for dark surfaces.
 * Thumb is hidden until the scroll container is hovered.
 */
export function getDarkSurfaceScrollbarSx(): CSSObject {
  return {
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
      borderRadius: 6,
    },
    '&:hover': {
      scrollbarColor: 'rgba(255, 255, 255, 0.35) transparent',
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(255, 255, 255, 0.35)',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(255, 255, 255, 0.5)',
      },
    },
  };
}

/**
 * Narrow scrollbar chrome for light surfaces.
 * Thumb is hidden until the scroll container is hovered.
 */
export function getLightSurfaceScrollbarSx(): CSSObject {
  return {
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
      borderRadius: 6,
    },
    '&:hover': {
      scrollbarColor: 'rgba(0, 0, 0, 0.25) transparent',
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.25)',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(0, 0, 0, 0.4)',
      },
    },
  };
}
